// QuizSoundOnService.ts
import { useState, useEffect } from 'react'; // React フックをインポート
/**
 * QuizSoundOnService
 * クイズの音声ON/OFF状態を管理するサービス
 */
class QuizSoundOnService {
    private static readonly STORAGE_KEY = 'quizSoundOn'; // 固定キー
  
    /**
     * 音声ON/OFF状態を保存
     * @param isOn 音声ON/OFFの状態 (boolean)
     */
    static setSoundOn(isOn: boolean): void {
      try {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(isOn));
      } catch (error) {
        console.error('Failed to save quiz sound state:', error);
      }
    }
  
    /**
     * 音声ON/OFF状態を取得
     * @param defaultValue デフォルト値 (デフォルト: true)
     * @returns 現在の音声状態
     */
    static getSoundOn(defaultValue: boolean = true): boolean {
      try {
        const item = localStorage.getItem(this.STORAGE_KEY);
        return item ? JSON.parse(item) : defaultValue;
      } catch (error) {
        console.error('Failed to get quiz sound state:', error);
        return defaultValue;
      }
    }
  
    /**
     * 音声状態をリセット
     */
    static resetSoundOn(): void {
      try {
        localStorage.removeItem(this.STORAGE_KEY);
      } catch (error) {
        console.error('Failed to reset quiz sound state:', error);
      }
    }
  }
  
  /**
   * useQuizSoundOn カスタムフック
   * クイズの音声ON/OFF状態をReact状態と同期
   * @returns [isSoundOn, setSoundOn]
   */
  function useQuizSoundOn(): [boolean, (value: boolean) => void] {
    const [isSoundOn, setIsSoundOn] = useState(() => {
      return QuizSoundOnService.getSoundOn();
    });
  
    useEffect(() => {
      QuizSoundOnService.setSoundOn(isSoundOn);
    }, [isSoundOn]);
  
    return [isSoundOn, setIsSoundOn];
  }
  
  export { QuizSoundOnService, useQuizSoundOn };